<template>
  <div class="container content-block">
    <div class="row mb-3 header">
      <div class="col-lg-8 col-12">
        <h2 class="title">{{ title }} Activiteiten</h2>
      </div>
      <div class="col-lg-4 col-12">
        <div class="btn-toolbar justify-content-between flex-nowrap" role="toolbar">
          <div class="input-group flex-grow-1 filter-search-group">
            <input type="text" v-model="searchQuery" class="form-control" placeholder="... zoeken"
                   aria-label="Recipient's username" aria-describedby="basic-addon2" @keyup.enter="search">
            <div class="input-group-append">
              <button class="btn btn-search" type="button" @click="search">
                <SearchIcon/>
              </button>
            </div>
          </div>
          <div class="btn-group">
            <QuestFilter @filter-updated="onFilterUpdated"></QuestFilter>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center" v-if="fetchingQuests">
        <div class="alert alert-primary" role="alert">
          Activiteiten ophalen.
        </div>
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Laden...</span>
          </div>
        </div>
      </div>
      <div class="col-12 text-center" v-else-if="quests.length === 0">
        <h3>Geen activiteiten gevonden.</h3>
      </div>
      <div class="col-12 quests" v-else>
        <!--        <QuestSmallCustom :quest-type="questTypeEnum.impulse" :title="'Beweeg tussendoor'" :points="1"-->
        <!--                          :interactable="true" v-show="showQuestImpulse"-->
        <!--                          @click="loadQuestImpulseDetails"></QuestSmallCustom>-->
        <QuestSmall :key="quest.id" v-for="quest in quests" :interactable="true" :quest="quest"></QuestSmall>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <Pagination :item-count="listInfo.totalElements" :items-per-page="itemsPerPage"></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import QuestSmall from "@/components/Quests/QuestSmall";
import Pagination from "@/components/UI/Pagination";
import { BuddyApi, QuestTypeEnum } from "sandpiper_api";
import log from "@/utils/logger";
import QuestFilter from "@/components/Filter/QuestFilter";
// import QuestSmallCustom from "@/components/Quests/QuestSmallCustom";

import SearchIcon from "@/assets/image/icons/icon-search.svg?inline";

export default {
  name: "QuestsContainer",
  components: { Pagination, QuestSmall, QuestFilter, SearchIcon },
  props: {
    title: String,
    selectedBuddy: Object
  },
  inject: [ 'doApiRequest' ],
  data()
  {
    return {
      fetchingQuests: false,
      quests: [],
      searchQuery: '',
      filterData: null,
      filterIsEmpty: true,

      page: 1,
      itemsPerPage: 30,
      listInfo: {},

      questTypeEnum: new QuestTypeEnum()
    }
  },
  computed: {
    // itemsPerPage()
    // {
    //   return this.showQuestImpulse ? 29 : 30;
    // },
    // showQuestImpulse()
    // {
    //   // We would have to create our own PageRequest implementation where we can pass through the offset ourselves,
    //   // because currently we would be losing item number 30 in this setup.
    //   // return this.filterIsEmpty && this.page === 1;
    //   return this.filterIsEmpty;
    // }
  },
  methods: {
    fetchQueryParams()
    {
      this.page = parseInt(this.$route.query.page) || 1;
      this.searchQuery = this.$route.query.search || '';
    },
    onFilterUpdated(filterData, isEmpty)
    {
      log.debug("Filter updated");
      this.filterData = filterData;
      this.filterIsEmpty = isEmpty;

      let params = { ...this.$route.query };
      if (params.page && params.page > 1)
      {
        delete params.page;
        this.$router.push({ path: this.$route.path, query: params });
      }
      else
      {
        this.fetchQuestsForBuddy();
      }
    },
    async fetchQuestsForBuddy()
    {
      console.log("Fetching Quests for Buddy");
      if (!this.selectedBuddy || this.fetchingQuests) return;

      try
      {
        this.fetchingQuests = true;

        this.quests = [];

        let params = {
          count: this.itemsPerPage,
          page: this.page - 1,
          questSearchQuery: this.searchQuery
        };

        if (this.filterData !== null && !this.filterIsEmpty)
        {
          params = Object.assign(params, this.filterData);
        }

        console.log(params);
        log.debug("List quest params: %o", params);


        //override for favourites. We want to get all quests at once, not paginated.
        //params.count = 9999;

        const response = await this.doApiRequest(() => new BuddyApi().getQuestsForBuddy(this.selectedBuddy.id, params));

        this.quests = response.quests;
        console.log(this.quests);
        
        await this.addPlannedStatus(this.quests);

        this.listInfo = {
          currentPage: response.currentPage,
          numberOfElements: response.numberOfElements,
          totalPages: response.totalPages,
          totalElements: response.totalElements
        };
      }
      catch (e)
      {
        // TODO - handle error
      }
      finally
      {
        this.fetchingQuests = false;
      }
    },

    async addPlannedStatus()
    {
      if (!this.selectedBuddy) return;

      try
      {

        const response = await this.doApiRequest(() => new BuddyApi().getBuddyActivities(this.selectedBuddy.id));

        let activities = response;

        this.quests.forEach(quest =>
        {
          //let activity = activities.find(act => act.quest.id === quest.id);
          let filteredActivities = activities.filter(act => act.quest.id === quest.id);

          let activity = this.getMostRecentActivity(filteredActivities);
          if (activity && activity.plannedDate > new Date())
          {
            if (activity.cancelledDate && activity.cancelledDate > activity.plannedDate)
            {
              return;
            }

            if (activity.completionDate && activity.completionDate > activity.plannedDate)
            {
              return;
            }

            quest.isPlanned = true;
          }

        })
      }
      catch (e)
      {
        // TODO - handle error
      }
    },
    getMostRecentActivity(activities)
    {
      let mostRecent = null;
      for (let i = 0; i < activities.length; i++)
      {
        if (mostRecent == null || activities[i].plannedDate > mostRecent.plannedDate)
        {
          mostRecent = activities[i];
        }
      }

      return mostRecent;
    },
    search()
    {
      let params = { ...this.$route.query };
      params.search = this.searchQuery;

      this.$router.push({ path: this.$route.path, query: params });
    },
    loadQuestImpulseDetails()
    {
      this.$router.push({
        name: "quest-detailed-grouped", params: {
          questType: this.questTypeEnum.impulse
        },
        query: {
          buddyId: this.selectedBuddy.id
        }
      });
    }
  },
  watch: {
    $route(to, from)
    {
      // We're only watching for param changes on the same page, ignore if we're going to a different page/component
      if (from.name === to.name)
      {
        log.debug("Route watch trigger:\nFrom: %o\nTo: %o", from, to);
        this.fetchQueryParams();
        this.fetchQuestsForBuddy();
      }
    },
    selectedBuddy(newValue, oldValue)
    {
      log.info("Selected buddy was updated\nfrom: %o\nto: %o", oldValue, newValue);
      if (newValue !== oldValue)
      {
        this.fetchQuestsForBuddy();
      }
    }
  },
  created()
  {
    this.fetchQueryParams();
  }
}
</script>

<style lang="scss" scoped>

.container {
  padding: 21px;
}

.quests {
  display: grid;
  //grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  grid-template-columns: repeat(1, minmax(275px, 1fr));
  grid-auto-rows: 50px;
  grid-gap: 10px 25px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(275px, 1fr));
  }

  @media (min-width: 992px) {
    grid-template-columns: repeat(3, minmax(275px, 1fr));
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  .title {
    font-size: 1.3rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }
}

.btn-toolbar {
  gap: 1rem;

  .filter-search-group {
    border-radius: 0.25rem;
    box-shadow: $default-shadow;

    input {
      border-color: transparent;
      height: auto;
    }
  }

  .btn-search, .btn-filter {
    background-color: $primary-blue;
    color: $font-light;

    svg {
      fill: $font-light;
      max-width: 23px;
      max-height: 23px;
    }
  }
}
</style>